import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';

import {
  getCommentsForum,
  postNewAnswer,
  postNewComment
} from 'store/lesson-actions';

import classes from './UserComment.module.css';

const UserComment = props => {
  const { t } = useTranslation(['forum']);
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.userInfo);
  const [forumComment, setForumComment] = useState('');

  const handleChange = event => {
    setForumComment(event.target.value);
  };

  const sendCommentHandler = () => {
    (async () => {
      if (props.subcomment) {
        const newAnswer = await postNewAnswer(
          props.idCourse,
          props.idLesson,
          forumComment,
          'es',
          props.idComment
        );
        if (newAnswer) {
          setForumComment('');
          props.showAnswers();
        }
      } else {
        const newPost = await postNewComment(
          props.idCourse,
          props.idLesson,
          forumComment,
          'es'
        );
        if (newPost) {
          setForumComment('');
          dispatch(
            getCommentsForum(props.idLesson, 'es', 50, 1, true)
          );
        }
      }
    })();
  };

  return (
    <>
      <figure className={classes.userImageContainer}>
        {userInfo.data.foto ? (
          <img
            className={classes.userImage}
            src={userInfo.data.foto}
            alt={userInfo.data.nombre}
          />
        ) : (
          <img
            className={classes.userImage}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/usuario12.png"
            alt={userInfo.data.nombre}
          />
        )}
      </figure>
      <TextField
        label={t('write_comment')}
        multiline
        maxRows={4}
        value={forumComment}
        onChange={handleChange}
        className={classes.forumInput}
      />
      <Button
        className={classes.commentForumBtn}
        onClick={sendCommentHandler}
        disabled={!forumComment}
      >
        {t('comment')}
      </Button>
    </>
  );
};

UserComment.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  subcomment: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  idComment: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  showAnswers: PropTypes.func
};

export default UserComment;
